/* eslint-disable react/jsx-props-no-spreading */
import { FormControlLabel, Switch as InMarKitSwitch, SwitchProps as InMarkitSwitchProps } from '@mui/material';
import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

interface SwitchProps extends InMarkitSwitchProps {
  name: string;
  label: string;
}

export default function Switch({ name, label, ...rest }: SwitchProps) {
  const { control } = useFormContext();
  const { field } = useController({ control, name });

  return (
    <FormControlLabel
      label={label}
      control={
        <InMarKitSwitch
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={field.name}
          inputRef={field.ref}
          checked={field.value}
          {...rest}
        />
      }
    />
  );
}
